module.exports = __webpack_public_path__ + "static/img/large-screen-bg1.9057cde4.png";